import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ListViewModel} from "../../shared/models/ui/list-view.model";
import {ImageGalleryModel} from "../../shared/models/ui/image-gallery.model";
import {ApiService} from "../../core/api/api.service";
import {AccessControlService} from "../../core/access-control/access-control.service";
import {customerRole} from "../../core/access-roles/customer.role";
import {
  FACILITY_TYPES,
  FIRE_PARTITION_STATUSES, FIRE_PARTITION_TYPES,
  FirePartition,
  FirePartitionTypeName,
  INSTALLATION_METHOD_TYPES, Material
} from "../../core/models/firepartition.type";
import {capitalizeFirstLetter} from "../../core/utils/utils";

@Component({
    selector: 'bergh-fire-partition-info',
    templateUrl: './fire-partition-info.component.html',
    styleUrls: ['./fire-partition-info.component.scss'],
    standalone: false
})
export class FirePartitionInfoComponent implements OnInit {
  @Input() firePartitionData: FirePartition;

  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() updateFirePartitions: EventEmitter<void> = new EventEmitter();
  saveMaterialsEvent: boolean = false;
  statusReportList: any = [];
  projectId: string;
  public tabs: string[] = [
    'Info',
    'Status rapport',
    'Afbeeldingen',
    'Materialen',
    'Documenten'
  ];
  currentUrl: string;
  isSealPage: boolean;
  public isCustomer: boolean = false;
  protected materialsDirty: boolean = false;

  public tableData: ListViewModel = {
    headers: [],
    data: [],
    secondaryButtonGroup: [],
    primaryButtonGroup: []
  };

  public imageData: ImageGalleryModel = {
    columns: 6,
    images: [],
  };
  public selectedTab: string;

  constructor(
    private _api: ApiService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _accessControl: AccessControlService,
  ) {
  }

  ngOnInit(): void {
    this.projectId = this._route.snapshot.paramMap.get('id')
    this.isCustomer = this._accessControl.getRoleCode() === customerRole.code
    if (!this.projectId) {
      this.projectId = this.firePartitionData.projectId;
    }
    this.changeTab(this.tabs[0]);
    this.currentUrl = this._router.url;
    this.isSealPage = this.currentUrl.includes("afdichtingen")
  }

  changeTab(tab: string): void {
    this.tableReset();
    this.selectedTab = tab;
    const dateTimeOptions: any = {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
    switch (tab) {
      case this.tabs[0]: {
        this.tableData.suppressHeader = true;
        this.tableData.headers = [{title: 'key', key: 'key'}, {
          title: 'value', key: 'value', style(value) {
            switch (value) {
              case 'Voldoet': {
                return 'text-0';
              }
              case 'Voldoet, mits': {
                return 'text-1';
              }
              case 'Voldoet niet': {
                return 'text-2';
              }
              case 'Foutieve invoer': {
                return 'text-3';
              }
              case 'Derde partij': {
                return 'text-4';
              }
              default: {
                return '';
              }
            }
          }
        }]
        this.tableData.data = [
          {
            key: 'Status',
            value: capitalizeFirstLetter(FIRE_PARTITION_STATUSES.get(this.firePartitionData.status).nameDutch)
          },
          {
            key: 'Zone naam',
            value: this.firePartitionData.zone.name,
          },
          {
            key: 'Aangemaakt door',
            value: this.firePartitionData.createdBy === null ? '' : this.firePartitionData.createdBy.name,
          },
          {
            key: 'Soort registratie',
            value:  this.firePartitionData.type !== null ? FIRE_PARTITION_TYPES.get(this.firePartitionData.type).nameDutch : '-',
          },
          {
            key: 'Meerwerk',
            value: this.firePartitionData.isExtraWork ? 'Ja' : 'Nee',
          },
          {
            key: 'Aanmaakdatum',
            value: new Date(this.firePartitionData.createdAt).toLocaleString('nl-NL', dateTimeOptions),
          },
          {
            key: 'QR code',
            value: this.firePartitionData.qrCode || '-',
          },
          {
            key: 'Verdieping',
            value: this.firePartitionData.floor || '-',
          },
          {
            key: 'Ruimte',
            value: this.firePartitionData.roomNumber === null ? '-' : this.firePartitionData.roomNumber,
          },
          {
            key: 'Positie',
            value: this.firePartitionData.position !== null ? (this.firePartitionData.position.nameDutch === '' ? '-' : this.firePartitionData.position.nameDutch) : '-',
          },
          this.firePartitionData?.position?.name === 'OTHERS' &&
          {
            key: 'Positie details',
            value: this.firePartitionData.positionOtherText || '-',
          },
          this.firePartitionData.type === FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY && {
            key: 'Item',
            value: FACILITY_TYPES.get(this.firePartitionData.facilityType)?.nameDutch || '-'
          },
          // this.firePartitionData.type === FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY && {
          //   key: 'Merk',
          //   value: this.firePartitionData.brand || '-',
          // },
          // this.firePartitionData.type === FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY && {
          //   key: 'Type',
          //   value: this.firePartitionData.model || '-',
          // },
          this.firePartitionData.type === FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY && {
            key: 'Adres/nr',
            value: this.firePartitionData.identification || '-',
          },
          this.firePartitionData.type === FirePartitionTypeName.INSTALLATION_TECHNICAL_FACILITY && {
            key: 'Montage',
            value: INSTALLATION_METHOD_TYPES.get(this.firePartitionData.installationMethod)?.nameDutch || '-',
          },
          (this.firePartitionData.type === FirePartitionTypeName.NORMAL || this.firePartitionData.type === FirePartitionTypeName.OTHER) &&  {
            key: 'Eis',
            value: this.firePartitionData.requirements !== null ? (this.firePartitionData.requirements.value === '' ? '-' : this.firePartitionData.requirements.value) : '-',
          },
          {
            key: 'Opmerkingen',
            value: this.firePartitionData.extra || '-',
          },
        ].filter(e => !!e);

        break;
      }
      case this.tabs[1]: {
        this.tableData.headers = [
          {
            title: 'Status gewijzigd naar', key: 'status', style(value) {
              switch (value) {
                case 'Voldoet': {
                  return 'text-0';
                }
                case 'Voldoet, mits': {
                  return 'text-1';
                }
                case 'Voldoet niet': {
                  return 'text-2';
                }
                case 'Foutieve invoer': {
                  return 'text-3';
                }
                case 'Derde partij': {
                  return 'text-4';
                }
                default: {
                  return '';
                }
              }
            }
          },
          {title: 'Door', key: 'door'},
          {title: 'Datum', key: 'datum'},
        ];
        this._api.request('getStatusReportDetails', `${this.firePartitionData._id}/status-reports`).subscribe((res: any) => {
          this.statusReportList = res;

          this.statusReportList.forEach(ele => {
            this.tableData.data.push(
              {
                status: capitalizeFirstLetter(ele.currentStatus.nameDutch),
                door: ele.updatedBy === null ? 'Klanten' : ele.updatedBy.name,
                datum: new Date(ele.updatedAt).toLocaleString('nl-NL', dateTimeOptions),
              }
            )
          })
        }, (error: any) => {
          console.error(error)
        })
        break;
      }
      case this.tabs[2]: {
        this.imageData.images = [];
        this.firePartitionData.pictures.forEach(ele => {
          this.imageData.images.push(ele.image)
        })

        break;
      }
      case this.tabs[3]: {
        break;
      }
      case this.tabs[4]: {
        break;
      }
      default: {
        break;
      }
    }
  }

  private tableReset() {
    this.tableData.headers = [];
    this.tableData.data = [];
    this.tableData.suppressHeader = false;
  }

  saveMaterial() {
    this.saveMaterialsEvent = true;
    this.updateFirePartitions.emit()
    this.materialsDirty = false
  }

  updateMaterials(materials: Material[] | undefined) {
    this.saveMaterialsEvent = false
    if (materials) {
      this.firePartitionData.materials = materials;
    }
    this.updateFirePartitions.emit()
  }

  updatePictures(pictures) {
    if (pictures) {
      this.firePartitionData.pictures = pictures;
    }
    this.updateFirePartitions.emit()
  }
}

